exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\np[data-v-4fead61a] {\n  font-size: 0.8em;\n  text-align: center;\n  margin-top: 5.5em;\n}\n", ""]);

// exports
